/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/modals/common/CustomDialog';
import { useMessageBar } from '../../../hooks/useMessageBar';
import CustomFileImageList from '../../../components/layouts/CustomFileImageList';
import { findFileImgList } from '../../../apis/file/File';
import { FileImgInfo } from '../../../models/admin/FileImgInfo';
import { isEmpty } from 'lodash';

interface Props {
  open: boolean;
  close: (isDone?: boolean) => void;
  title: string;
  fileData: any;
  fileType?: string;
  onCallbackData: any;
}
/**
 * 사유입력팝업
 *       1. DROP - Drop : MP010
 *       2. 개발재검토 : ?
 *       3. DLBR_CPLT -   심의완료(수평전개 재진행): 수평전개 진행 /보류 선택 MP006
 * @param open
 * @param close
 * @param title
 * @param initParam
 * @param onCallbackData
 */
export const MpFileImgViewPopUp = ({ open, close, fileData, fileType }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();
  const [groupsTitle, setGroupsTitle] = useState<any>([]);
  const [groupsData, setGroupsData] = useState<{ [key: string]: FileImgInfo[] }>({});

  //init
  useEffect(() => {
    getPreviewImage();
  }, []);

  const getPreviewImage = () => {
    findFileImgList(fileData).then((data) => {
      const resultData = isEmpty(fileType) ? data : data.filter((o) => o.optValCtn1 === fileType);

      if (resultData) {
        const groupedData = resultData.reduce((groups, item) => {
          const key = JSON.stringify({ groupId: item.atchFileGrId, id: item.atchFileId });
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(item);
          return groups;
        }, {});

        const groupedTitleData = resultData.reduce((groups, item) => {
          const key = JSON.stringify({ groupId: item.atchFileGrId, id: item.atchFileId });
          if (!groups[key]) {
            groups[key] = [];
          } else {
            return groups;
          }
          groups[key].push({ key: key, atchFileNm: item.atchFileNm });
          return groups;
        }, {});

        const resultGroupTitle = Object.values(groupedTitleData);

        setGroupsTitle(resultGroupTitle);
        setGroupsData(groupedData);
      }
    });
  };

  return (
    <>
      <CustomDialog
        title={'미리보기'}
        open={open}
        onClose={close}
        size={'xl'}
        // buttons={''}
      >
        {groupsTitle.map((item, index) => (
          <CustomFileImageList
            key={index}
            listIndex={index}
            itemTitle={item[0].atchFileNm}
            itemList={groupsData[item[0].key]}
            imageCols={2}
            imageGaps={5}
          />
        ))}
      </CustomDialog>
    </>
  );
};
